import types from "./types";

const INITIAL_STATE = {
	organizationProfileFormBuilder: null,

	organizationProfileFormBuilderError: null,
	organizationProfileFormBuilderLoading: false,

	//select item

	selectItem: null,
};

const OrganizationProfileFromReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_ORGANIZATIONPROFILEFORMLIST_START:
			return {
				...state,
				organizationProfileFormBuilder: null,
				organizationProfileFormBuilderError: null,
				organizationProfileFormBuilderLoading: true,
			};
		case types.GET_ORGANIZATIONPROFILEFORMLIST_SUCCESS:
			return {
				...state,
				organizationProfileFormBuilder: action.payload,
				organizationProfileFormBuilderLoading: false,
			};
		case types.GET_ORGANIZATIONPROFILEFORMLIST_ERROR:
			return {
				...state,
				organizationProfileFormBuilderError: action.payload,
				organizationProfileFormBuilderLoading: false,
			};
		case types.GET_ORGANIZATIONPROFILEFORMLIST_RESET:
			return {
				...state,
				organizationProfileFormBuilderError: null,
				organizationProfileFormBuilderLoading: false,
			};
		//create

		case types.SELECT_TOUPDATE_ITEM:
			return {
				...state,
				selectItem: action.payload,
			};

		default:
			return { ...state };
	}
};

export default OrganizationProfileFromReducer;
